export const FEE_RULES_ROUTE_PATHS = {
  feeRules: '/finance/fee-rules',
};

export const FEE_RULES_API_PATHS = {
  feeRules: '/v1/api/platform/fee-rules',
};
